module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('a', {
    attrs: {
      "id": "chapter05"
    }
  }), _vm._v("CHAPTER FIVE")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("San Francisco, California")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("Monday, February 15")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("2:20 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("P.M")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Alex parked in front of her mother’s Victorian row house, one of San Francisco’s famed “painted ladies.” She hadn’t appreciated growing up here until after she was grown. Typical kid, she supposed. Longing for what she didn’t have instead of enjoying what she did.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Alex set the emergency brake and climbed out of her Toyota Prius. She had spent the past six days searching for the source of her “vision,” as she had come to refer to it. So far, she’d come up empty.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("She re-cinched her caramel-colored trench and started up the walk. Although frustrated, she had gradually become less troubled over the incident. She’d told herself it’d been a onetime thing, an aberration of sorts. Certainly nothing to get worked up about.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Alex scooped up her mother’s newspaper, then let herself into the home. The smell of oil paints and turpentine stung her nose. Her mother had been working.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Mom,” she called, “it’s Alex.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“On the porch, honey.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Alex made her way down the central hallway. The living room and dining room were both a wreck. Furniture pushed to the walls; floors covered by drop cloths; easels with works in progress; canvases propped against every available surface.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Her mother had long ago given up any semblance of normalcy in the way she lived. Even before Alex had gone off to college, her mother’s art had begun "), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _vm._v("gobbling square footage, until nothing but Alex’s bedroom and the bathrooms remained untouched. A sort of metaphor for her mother’s mental illness—there were very few areas of their lives it didn’t touch.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Alex dropped the newspaper on the kitchen counter and crossed to the doors to the patio. They stood open and she paused, the chilly air enveloping her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Her mother, still a striking beauty at fifty-four, sat sketching at the café table on the patio, a pot of French press coffee and an untouched croissant beside her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Alex resembled her—the same dark hair and fine features. The same almond-shaped eyes. But she had always seen herself as a watery reflection of her mother’s dramatic beauty—her hair wasn’t as inky, her skin not as alabaster, her eyes a sensible hazel instead of clear green.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Now, the sun fell across her mother’s silky black hair, illuminating the inky highlights as her pencil flew across the pages, flitting almost frenetically from one sketch to another. She wasn’t wearing a coat but seemed oblivious to the cold.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("All the signs of a full-blown manic episode, Alex acknowledged. She stepped onto the porch, crossed to her mother, and dropped a kiss on the top of her head. “I see you’ve been working. Anything you loved?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Her mother looked up at her. “Several things. It was a wonderful session. Just wonderful.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Why don’t you come inside? You’ll catch your death out here.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Her mother waved off the concern. “These are the ones, Alex. The ones I’ll be remembered for. Grab yourself a cup of coffee or a juice and take a look.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("A moment later, glass of orange juice in her hand, Alex studied the works in progress. There were at least twenty of them, in various stages of completion. Swirling colors, brilliant. Organic shapes, vibrating with life. Stunning.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("She gazed at them, a catch in her chest. Her mother could have been an important artist. Could have been. Hard to have a real career without a consistent body of work. Or when you committed to showings, then backed out at the last moment.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Alex sipped the juice. How long had she worked without stopping to eat or sleep? Twelve hours? Twenty-four? More than that? At least when Alex still lived here, she’d been able to coax her mother to eat. Had been able to keep tabs on her. Make certain she rested and took her medication.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _vm._v("“What do you think?” her mother called from the kitchen.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Incredible,” she called back, heading that way. She found her mother standing at the counter, newspaper spread open before her. She was humming as she read. “They’re really wonderful, Mom.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Her mother smiled. “Some of my best work. Certainly the best in years.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("How many times had she heard those same words from her mother? Too many to count. And each time it had ended the same way.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“May I have one of them?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Silly.” Her mother’s hands fluttered. “None of them are complete.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("And most likely, they never would be.")]), _vm._v(" “I’d like one anyway. Would you mind?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Her mother laughed. “Strange girl. But if it’s that important to you, take any one you like.” She snapped on the radio; Fleetwood Mac’s late seventies rock classic “Don’t Stop” filled the room. Her mother rocked to the beat. “This song brings back memories.” She snapped her fingers. “I was quite the wild child. The Eagles, Peter Frampton, the Grateful Dead, I saw them all.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“You’re not taking your medication, are you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Her mother frowned. “Don’t start, please.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“You need your meds, Mom.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I don’t like the way they make me feel.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“They keep you even.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“If feeling like a zombie is ‘even,’ you can have it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“We’ve talked about this before. Now you feel unstoppable, but—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("She waved off Alex’s concern. “Nothing you say can pop my bubble today.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Mother, plea—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“No, no, no.” She sank onto a chair and reached for Alex’s hands. “I don’t want to argue. Please, let’s not.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I’m just worried about you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“No need, I’m on top of the world.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("On top of the world now, Alex thought minutes later as she placed the canvas she’d chosen in her old bedroom. But the moment’s lofty perch meant a steep plunge later.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("She moved her gaze over the room’s girlish furnishings and the small collection of works in progress she had stored here. She thought of it as an archiving method. A way to ensure that someday her mother would have a body of work to look back on, even if they were incomplete works.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _vm._v("She locked the door, then headed back down the wide staircase. Her mother stood at the bottom, gazing up at her. “You’re a funny girl,” she said affectionately.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Alex reached the landing. “I come by it honestly.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“That you do.” She cupped her face in her palms. “My pretty, pretty girl. So different than—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("She bit the words back and spun away, humming, heading back toward the kitchen.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Than who, Mom?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Her mother stopped in the doorway. “Than everyone, silly.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Alex gazed at her mother, battling twin feelings of frustration and resignation. They had been through this a hundred times. At least. Her mother would hint at something or someone from their past, then refuse to say more.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("She tried again anyway. “What’s so horrible about my dad that you won’t tell me about him?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I don’t know who your father was. You know that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Alex followed her into the kitchen. It wouldn’t do any good to argue with her. To plead and cajole. She had tried that. Nor would questions about her mother’s family and past provide clues. All she knew was her mother’s parents had disowned her when she’d gotten pregnant.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Alex snatched her purse off the table and slung it over her shoulder. “I have to go to work.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Her mother didn’t respond. Alex crossed to the doorway, stopped and looked back at her. Something in the newspaper had caught her attention and she was gazing down at it as if she had already forgotten Alex was there.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("What was the point of pushing? Of getting angry or wishing for something that would never happen?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The truth was, her mother didn’t have the emotional wherewithal for an honest relationship.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Goodbye, Mom.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Her mother looked up, her expression strange. “You’re leaving?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Going to work.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("She frowned slightly. Her bubble had popped, Alex realized. And she had begun her descent.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“All I’ve ever wanted to do was protect you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“From what, Mom?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _vm._v("But she’d already returned to the newspaper. Alex let herself out and crossed to her car. She slid inside and started it, only then looking back at the house. She half expected to find her mother standing at the window, watching her go. Instead, the windows were empty.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("Empty")]), _vm._v(". The way these visits always left her feeling. She pulled away from the curb, thinking again of her mother’s words. "), _c('em', [_vm._v("“All I’ve ever wanted to do was protect you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("But from what? she wondered. From who?")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fb9ee61","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter05.vue
// module id = 96
// module chunks = 0